import { UtiqAPIMethodsType } from '@shared/api/types';
import { APIMethodNameType } from '@utiqLoader/types';

export const APIMethods: UtiqAPIMethodsType = {
  addEventListener: {
    name: 'addEventListener',
    errorMessage: '',
  },
  getUtiqConsentStatus: {
    name: 'getUtiqConsentStatus',
    errorMessage: '',
  },
  getIdGraphEntry: {
    name: 'getIdGraphEntry',
    errorMessage: '',
  },
  handleConsentChange: {
    name: 'handleConsentChange',
    errorMessage: '',
  },
  handleDataClear: {
    name: 'handleDataClear',
    errorMessage: '',
  },
  removeEventListener: {
    name: 'removeEventListener',
    errorMessage: '',
  },
  revokeConsentWithPopup: {
    name: 'revokeConsentWithPopup',
    errorMessage: '',
  },
  resetLoggingLevel: {
    name: 'resetLoggingLevel',
    errorMessage: '',
  },
  setVerboseLoggingLevel: {
    name: 'setVerboseLoggingLevel',
    errorMessage: '',
  },
  setLogLevel: {
    name: 'setLogLevel',
    errorMessage: '',
  },
  showConsentManager: {
    name: 'showConsentManager',
    errorMessage: '',
  },
  showRevocationPopupWindow: {
    name: 'showRevocationPopupWindow',
    errorMessage: '',
  },
  showConsentModal: {
    name: 'showConsentModal',
    errorMessage: '',
  },
  setConfig: {
    name: 'setConfig',
    errorMessage: '',
  },
  getConfig: {
    name: 'getConfig',
    errorMessage: '',
  },
  syncVersionCookiesOnConsent: {
    name: 'syncVersionCookiesOnConsent',
    errorMessage: '',
  },
};

/**
 * Gets the error message or generates a default for an unavailable API method.
 *
 * @param methodName - The name of the API method (from APIMethodNameType) that is unavailable.
 * @returns A string containing the error message.
 */
export const getErrorMessage = (methodName: APIMethodNameType) => {
  return (
    APIMethods[methodName]?.errorMessage ||
    `Method "${methodName}" is currently unavailable, because of current SDK internal state.`
  );
};

/**
 * Sets the en error message for a specific API method in the APIMethods configuration.
 *
 * @param methodName - The name of the API method (from APIMethodNameType) to update.
 * @param errorMessage - The error message to set.
 */
export const setErrorMessageForAPIMethod = (
  methodName: APIMethodNameType,
  errorMessage?: string,
) => {
  APIMethods[methodName].errorMessage = errorMessage;
};
